module.exports = __webpack_public_path__ + "static/media/js-calculator.df68a38f.png";